menuNavHandler  = {
    $smallMenuButton = $('.small-menu-button'),
    $smallHeaderNav = $('.small-header-nav'),
    $closeNavButton = $('.close-nav-button'),
    $smallFooterNavLink = $('.small-footer-nav-link'),

    openCloseMenu = function(){
        this.$smallHeaderNav.toggleClass('active');
        $('html').toggleClass('disable-scroll');
    },

    closeMenu = function(){
        this.$smallHeaderNav.removeClass('active');
        $('html').removeClass('disable-scroll');
    },

    scrollToInternal: function(hash) {
		var $target = $('#'+hash);
		if ($target.length > 0) {
            var top = $target.offset().top;
            top -= (parseInt($target.css('padding-top')) + parseInt($target.css('margin-top')));
            top -= $('header').outerHeight();
			window.scrollTo({top: top, behavior: 'smooth'});
		}
    },

    init = function() {
        var self = this;

        self.$smallMenuButton.on('click', function(e) {
            e.preventDefault();
            self.openCloseMenu();
        });

        self.$closeNavButton.on('click', function(e) {
            e.preventDefault();
            self.openCloseMenu();
        });

        self.$smallFooterNavLink.on('click', function(e){
            self.openCloseMenu();
        })

        self.$smallFooterNavLink.filter('[href*="#contact"]').on("click", function(e) {
            e.preventDefault();
            var $contact = $("#contact");
            if ($contact.length > 0) {
                self.scrollToInternal('contact');
            } else {
                document.location = $(this).attr('href');
            }
        });
    }
}